import React, { useState, useRef } from 'react';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import {
    getObjectFromArray,
    isIOSiPhoneDevice,
    getAdditionalTextareaLimit,
    debounce,
    logErrorToConsole,
} from 'src/utils/util';
import {
    TemplateTitleContainer,
    TemplateTitle,
    Icon,
    AccountPhysicianProceduContainer,
    AccPhysProceTitle,
    AccPhysProceValue,
    TemplateContainer,
    CommonItemsMainContainer,
    CommonItemsContainer,
    FooterContainer,
    FavoriteIconContainer,
    ChipContainer,
    CustomizeRowView,
    DeleteIconView,
    AutoCompleteDiv,
    RowContainer,
    AccountGroup,
    FavouriteIcon,
    MainContainerItems,
    ExpirationTitle,
} from './CreateTemplate.styled';
import Close from 'src/assets/images/CloseProduct.svg';
import DeleteIcon from 'src/assets/images/DeleteLight.svg';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import Select from 'src/common/refactoredComponents/select/Select';
import Notes from 'src/common/components/notes';
import Chip from 'src/common/refactoredComponents/chipComponent/index';
import FavoriteActive from 'src/assets/images/FavoriteActive.svg';
import FavoriteInActive from 'src/assets/images/favorite-inactive.svg';
import { accountNumberZeroTrimmer } from 'src/utils/util';
import {
    getDropdownValues,
    createTemplate,
    resetCreateTemplate,
    clearSingleDropDownList,
    loadAllPhyscianLoading,
    getRequiredDataFromOrder,
} from 'src/pages/equity/redux/actions';
import AccountPhysicianTemplate from 'src/pages/scheduleSurgery/components/details/AccountPhysicianTemplate';
import { Input } from 'src/common/components/form';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { sizes } from 'src/styles/Media.styled';
import { SelectedCurrentLoc } from 'src/pages/scheduleSurgery/components/shipping/NonTissueProductCard.styled';
import AddedMoreThanTenItems from 'src/pages/equity/components/surgery/notifications/AddedMoreThanTenItems';
import { isMobileDevice } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import {
    ALLDISTRICTS,
    ALLTERRITORIES,
    CC_USER_ROLE,
    ITA_USER_ROLE,
    pageNames,
    TEMPLATES
} from 'src/constants/appConstants';
import { useDynatracePageName } from 'src/common/hooks/useDynatracePageName';
import EquityFooter from '../EquityFooter';
import { EQUITYORDERTYPE } from '../constants';
import CalendarIcon from 'src/assets/images/CalendarIcon.svg';
import DatePicker from 'src/common/components/datePicker/DatePicker';
import { getUser } from 'src/pages/equity/components/common/utils/eventHandlerUtil';
import { getPlaceholderDateFormat } from 'src/utils/dateUtils';
import { getConfigurations } from 'src/common/redux/actions';

const CreateTemplate = ({
    origin = '',
    orderData: myCaseRef,
    handleClose,
    onOpen = () => {},
    onClose = () => {},
    orderPageMobilePadding,
    footerButtonSize,
    footerButtonMargin,
    isFromOrderHistory = false,
}) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [filteredAccountList, setFilteredAccountList] = useState([]);
    const [, setFilteredPhycianList] = useState([]);
    const [accountValue, setAccountValue] = useState('');
    const [templateNote, setTemplateNote] = useState('');
    const [templateParams, setTemplateParams] = useState({
        cartData: {},
        templateDetails: {},
        templateUID: '',
    });
    const [accountsObjectList, setAccountsObjectList] = useState([]);
    const [, setPhysicianObjectList] = useState([]);
    const [templateName, setTemplateName] = useState();
    const [isFavorite, setFavorite] = useState(false);
    const favoriteOrUnfavorite = () => {
        setFavorite(!isFavorite);
    };
    const [physicianInputValue, setPhysicianValue] = useState('');
    const [disableFields, setDisableFields] = useState({
        account: false,
        physician: false,
    });
    const [templateNotesPopup, setTemplateNotesPopup] = useState(false);
    const [textAreaCharLimit, setTextAreaCharLimit] = useState(4000);
    const [isDataFromOrderAPI, setConsideringDataFromAPI] = useState(false);
    const [templateNameErrorMsg, setTemplateNameErrorMsg] = useState(null);
    const {
        equityDetails,
        districts,
        districtId,
        territoryId,
        territories,
        accounts,
        accountId,
        physicianId,
        physicians,
        procedures,
        cartProduct,
        surgeryNotes,
        accountsOptionLoading,
        physicianLoadAllLoading,
        procedureCode,
        createTemplateStore,
        orderTemplateStore,
        territory,
        // employeeRole,
    } = useSelector((state) => ({
        equityDetails: state.equityReducer.equityDetails,
        districtId: state.equityReducer.equityDetails.districtId,
        territoryId: state.equityReducer.equityDetails.territoryId,
        accountId: state.equityReducer.equityDetails.accountId,
        accounts: state.equityDetailsDropdownsReducer.accounts.items,
        physicianId: state.surgeryReducer.surgeryDetails.physicianId,
        physicians: state.detailsDropdownsReducer.physicianList.items,
        districts: state.equityDetailsDropdownsReducer.districts.items,
        territories: state.equityDetailsDropdownsReducer.territories.items,
        procedures: state.detailsDropdownsReducer.procedureList.items,
        territory: state.detailsDropdownsReducer.territories,
        cartProduct: state.equityReducer.cartData.products,
        surgeryNotes: state.surgeryReducer.notes,
        accountsOptionLoading:
            state.equityDetailsDropdownsReducer.accounts.loading,
        procedureCode: state.surgeryReducer.surgeryDetails.procedureCode,
        createTemplateStore: state.equityProductTemplatesReducer.createTemplate,
        physicianLoadAllLoading:
            state.detailsDropdownsReducer.physicianList.physicianLoadAllLoading,
        orderTemplateStore: state.equityProductTemplatesReducer.orderTemplate,
        // employeeRole: state.loginReducer.hybrisUserDetails.employeeRole,
    }));
    const accountRef=useRef(null);
    const employeeRole = getUser();
    const date = new Date();
    const [surgeryDate, setSurgeryDate] = useState('');
    const { loadAll } = useSelector((state) => ({
        loadAll: state.detailsDropdownsReducer.physicianList.loadAll,
    }));
    const [Procedure, setProcedure] = useState(procedureCode);
    const [physiciantype] = useState(
        physicianId?.isFavorite ? 'favorites' : 'Territory'
    );
    const [selectedDistrictId, setSelectedDistrict] = useState(districtId);
    const [selectedTerritoryId, setSelectedTerritory] = useState(territoryId);
    const [dropdownHeight, setDropdownHeight] = useState('1');
    const [orderDataStatus, setOrderDataStatus] = useState({
        isAccountSet: false,
        isPhysicianSet: false,
        isProcedureSet: false,
        isDistrictSet: false,
        isTerritorySet: false,
        setProducts: [],
        itemProducts: [],
        districtId: '',
        territoryId: '',
        itemProductsCount: 0,
        setProductsCount: 0,
    });

    useDynatracePageName(pageNames.equityCreateTemplate);
    useEffectWithErrorLogging(() => {
        setTemplateParams({
            ...templateParams,
            templateDetails: {
                ...templateParams.templateDetails,
                accounts: accountId?.accountId ? [accountId.accountId] : [],
                addToFavorite: false,
                districtId: districtId,
                notes: surgeryNotes,
                physicians: physicianId?.physicianId
                    ? [physicianId.physicianId]
                    : [],
                procedureCode: procedureCode,
                templateName: '',
                templateType: 'equity',
                territoryId: territoryId,
            },
        });
        accountId && setAccountsObjectList([{ ...accountId }]);
        physicianId && setPhysicianObjectList([{ ...physicianId }]);
        setProcedure(procedureCode);
        return () => {
            setOrderDataStatus({
                isAccountSet: false,
                isPhysicianSet: false,
                isProcedureSet: false,
                isDistrictSet: false,
                isTerritorySet: false,
                setProducts: [],
                itemProducts: [],
                districtId: '',
                territoryId: '',
                itemProductsCount: 0,
                setProductsCount: 0,
            });
            setTemplateParams({
                cartData: {},
                templateDetails: {},
                templateUID: '',
            });
        };
    }, []);

    useEffectWithErrorLogging(() => {
        if (origin && myCaseRef) {
            handleFromCalendar();
        }
    }, [myCaseRef]);

    const handleFromCalendar = () => {
        if (!districts?.length) {
            dispatch(getDropdownValues({ dropDownName: 'districts' }));
        }
        if (!procedures?.length) {
            dispatch(getDropdownValues({ dropDownName: 'procedureList' }));
        }
        if (!physicians?.length) {
            getPhysicianList({
                searchValue: '',
                loadAll: true,
                sapPartnerId: equityDetails.accountId.accountId,
            });
        }
        setConsideringDataFromAPI(true);
        dispatch(
            getRequiredDataFromOrder({
                isMyCASERef: true,
                MyCASERef: myCaseRef,
                orderType: EQUITYORDERTYPE,
                isFromOrderHistory: isFromOrderHistory,
            })
        );
    };

    useEffectWithErrorLogging(() => {
        if (!territories?.length && districts.length > 0) {
            if (!selectedDistrictId) {
                setSelectedDistrict(
                    orderTemplateStore.districtUID
                        ? orderTemplateStore.districtUID
                        : districts[0].districtCode
                );
            }
            const districtIdValue = selectedDistrictId
                        ? orderTemplateStore.districtUID
                            ? orderTemplateStore.districtUID
                            : selectedDistrictId
                        : districts[0].districtCode;
            dispatch(
                getDropdownValues({
                    dropDownName: 'territories',
                    value: districtIdValue === ALLDISTRICTS ? '' : districtIdValue,
                })
            );
        }
    }, [districts]);

    useEffectWithErrorLogging(() => {
        if (
            origin &&
            isDataFromOrderAPI &&
            Object.values(orderTemplateStore).length > 3
        ) {
            const {
                accountsSelected = [],
                physiciansSelected = [],
                itemProductsCount = 0,
                setProductsCount = 0,
                procedureSelected,
                territoryUID,
                districtUID,
                templateType = 'equity',
            } = orderTemplateStore;
            let accountsSelectedIds = [];
            let physicianIds = [];
            let currentStatus = Object.assign({}, orderDataStatus);
            if (
                !currentStatus.isAccountSet &&
                accounts?.length &&
                accountsSelected.length
            ) {
                accountsSelectedIds = accountsSelected.map(
                    (ac) => ac?.accountId
                );
                const selectedAccounts = accounts.filter((ac) =>
                    accountsSelectedIds.includes(ac.accountId)
                );
                selectedAccounts?.length &&
                    setAccountsObjectList([...selectedAccounts]);
                currentStatus.isAccountSet = true;
            }
            if (
                !currentStatus.isPhysicianSet &&
                physicians?.length &&
                physiciansSelected.length
            ) {
                physicianIds = physiciansSelected.map((ph) => ph?.physicianId);
                const selectedPhysicians = physicians.filter((phy) =>
                    physicianIds.includes(phy.physicianId)
                );
                selectedPhysicians?.length &&
                    setPhysicianObjectList([...selectedPhysicians]);
                currentStatus.isPhysicianSet = true;
            }
            if (!currentStatus.isProcedureSet && procedureSelected) {
                setProcedure(procedureSelected);
                currentStatus.isProcedureSet = true;
            }
            if (!currentStatus.isDistrictSet && districtUID) {
                currentStatus.isDistrictSet = true;
                setSelectedDistrict(districtUID);
            }
            if (!currentStatus.isTerritorySet && territoryUID) {
                currentStatus.isTerritorySet = true;
                setSelectedTerritory(territoryUID);
            }
            accounts.length == 0 &&
                getAccountList(
                    {
                        searchValue: '',
                    },
                    districtUID,
                    territoryUID
                );
            currentStatus.itemProductsCount = itemProductsCount;
            currentStatus.setProductsCount = setProductsCount;
            currentStatus.itemProducts = orderTemplateStore?.itemProducts;
            currentStatus.setProducts = orderTemplateStore?.feeProducts;
            setOrderDataStatus(currentStatus);
            if (currentStatus.isAccountSet || currentStatus.isPhysicianSet) {
                setTemplateParams({
                    ...templateParams,
                    templateDetails: {
                        ...templateParams.templateDetails,
                        accounts: templateParams.templateDetails?.accounts
                            ?.length
                            ? templateParams.templateDetails?.accounts
                            : accountsSelectedIds?.length
                            ? [...accountsSelectedIds]
                            : [],
                        addToFavorite: false,
                        districtId: districtUID,
                        notes: '',
                        physicians: templateParams.templateDetails?.physicians
                            ?.length
                            ? templateParams.templateDetails?.physicians
                            : physicianIds?.length
                            ? [...physicianIds]
                            : [],
                        procedureCode: procedureSelected,
                        templateName: '',
                        templateType: templateType,
                        territoryId: territoryUID,
                    },
                });
            }
        }
    }, [
        orderTemplateStore,
        districts,
        territories,
        employeeRole == CC_USER_ROLE || employeeRole == ITA_USER_ROLE
            ? null
            : accounts,
        physicians,
        procedures,
    ]);

    useEffectWithErrorLogging(() => {
        if (origin && isFromOrderHistory && orderTemplateStore?.districtUID) {
            dispatch(
                clearSingleDropDownList({
                    name: 'territories',
                })
            );
            dispatch(
                getDropdownValues({
                    dropDownName: 'territories',
                    value:
                        orderTemplateStore.districtUID === ALLDISTRICTS
                            ? ''
                            : orderTemplateStore.districtUID,
                })
            );
        }
    }, [orderTemplateStore?.districtUID]);

    useEffectWithErrorLogging(() => {
        if (accounts) {
            const filteredAccountList = accounts.filter((it) => {
                if (templateParams?.templateDetails?.accounts) {
                    return !templateParams.templateDetails.accounts.includes(
                        it.accountId
                    );
                }
                return true;
            });
            setFilteredAccountList(filteredAccountList);
        }
        if (physicians) {
            const filteredPhysicianList = physicians.filter((it) => {
                if (templateParams?.templateDetails?.physicians) {
                    return !templateParams.templateDetails.physicians.includes(
                        it.physicianId
                    );
                }
                return true;
            });
            setFilteredPhycianList(filteredPhysicianList);
        }
    }, [accounts, physicians, templateParams]);

    useEffectWithErrorLogging(() => {
        if (createTemplateStore.statusCode == '200') {
            dispatch(resetCreateTemplate());
            handleClose(false);
        }
        if (createTemplateStore.statusCode == '10828') {
            setTemplateNameErrorMsg(createTemplateStore.statusMessage);
            setTemplateNotesPopup(true);
            closekeyBoard();
            dispatch(resetCreateTemplate());
        }
        if (createTemplateStore.statusCode == '10007') {
            setTemplateNameErrorMsg('Territory field is required');
            setTemplateNotesPopup(true);
            closekeyBoard();
            dispatch(resetCreateTemplate());
        }
    }, [createTemplateStore]);

    const handleAddAccountToTemplate = (value) => {
        if (value) {
            const newAccount = {
                accountId: value.accountId,
                accountName: value.accountName,
            };
            const newAccountsList = [
                ...templateParams.templateDetails.accounts,
                value.accountId,
            ];
            const newAccountsListWithObject = [
                ...accountsObjectList,
                newAccount,
            ];
            setTemplateParams({
                ...templateParams,
                templateDetails: {
                    ...templateParams.templateDetails,
                    accounts: newAccountsList,
                },
            });
            setAccountsObjectList(newAccountsListWithObject);
        }
    };

    const handleRemoveAccountFromTemplate = (event) => {
        const accountIdToRemove = event.target.id;
        const newAccountsList = [
            ...templateParams.templateDetails.accounts,
        ].filter((item) => item !== accountIdToRemove);
        const newAccountsListWithObject = [...accountsObjectList].filter(
            (item) => item.accountId !== accountIdToRemove
        );
        setTemplateParams({
            ...templateParams,
            templateDetails: {
                ...templateParams.templateDetails,
                accounts: newAccountsList,
            },
        });
        setAccountsObjectList(newAccountsListWithObject);
    };

    const getViewWidth = () => {
        switch (window.innerWidth) {
            case sizes.smalDevice:
                return '18vw';
            case sizes.mediumDevice:
                return '20vw';
            case sizes.mobileDevice:
                return '44vw';
            default:
                return '65%';
        }
    };

    const getAddressWidth = () => {
        switch (window.innerWidth) {
            case sizes.smalDevice:
                return '40%';
            default:
                return '48%';
        }
    };

    const AccountTemplate = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                nameWidth={getViewWidth()}
                addressWidth={getAddressWidth()}
                option={option}
                data={fieldname == 'account' ? accounts : physicians}
                optionValue={
                    fieldname == 'account'
                        ? 'accountId'
                        : physicians?.length
                        ? 'physicianId'
                        : ''
                }
                fieldname={fieldname}
                onLoadMore={() => {
                    try {
                        handleLoadAll(true);
                    } catch (error) {
                        logErrorToConsole(error);
                    }
                }}
                showLoadMore={!loadAll}
                showOptionLoader={physicianLoadAllLoading}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };

    const handleLoadAll = (loadAnimation) => {
        setPhysicianValue('');
        dispatch(loadAllPhyscianLoading(loadAnimation ? loadAnimation : false));
        getPhysicianList({
            searchValue: '',
            loadAll: true,
            sapPartnerId: equityDetails.accountId.accountId,
        });
    };

    const handleOnfocus = (event, field) => {
        if (field == 'accounts') {
            getAccountList({
                searchValue: event?.target?.value?.trim() || '',
            });
        }
    };
    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const getPhysicianList = (data) => {
        const { loadAll, type } = data;
        let params = {
            physicianType: type
                ? type
                : physiciantype == 'favorites'
                ? 'Favorites'
                : 'All',
            isLoadAll: loadAll,
            isSurgeryFlow: true,
            searchTerm: physicianInputValue ? physicianInputValue : '',
            // sapPartnerId: equityDetails.accountId.accountId
        };

        dispatch(
            getDropdownValues({
                dropDownName: 'physicianList',
                value: params,
                salesOrg: salesOrg,
                countryISOCode: countryISOCode,
            })
        );
    };
    const getAccountList = (data, districtIdFromEdit, territoryIdFromEdit) => {
        let params = {
            district: selectedDistrictId
                ? selectedDistrictId
                : districtIdFromEdit,
            territory: selectedTerritoryId
                ? selectedTerritoryId
                : territoryIdFromEdit,
            searchParam: accountValue ? accountValue : '',
        };
        if (!accounts?.length) {
            dispatch(
                getDropdownValues({ dropDownName: 'accounts', value: params })
            );
        }
    };

    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;

    const handleSearch = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            let option = {
                searchValue: value,
                sapPartnerId: equityDetails.accountId.accountId,
            };
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                debouncedGetList(getPhysicianList, option);
            } else if (fieldname == 'account') {
                setAccountValue(value);
                debouncedGetList(getAccountList, option);
            }
        } else {
            if (fieldname == 'physician') {
                setPhysicianValue('');
            } else if (fieldname == 'account') {
                setAccountValue('');
            }
        }
    };

    const handleTemplateName = (e) => {
        setTemplateName(e?.target?.value);
    };

    useEffectWithErrorLogging(() => {
        if (
            isIOSiPhoneDevice() &&
            templateNote &&
            templateNote.length > 0 &&
            getAdditionalTextareaLimit(templateNote) > 0
        ) {
            setTextAreaCharLimit(
                4000 + getAdditionalTextareaLimit(templateNote)
            );
        } else {
            setTextAreaCharLimit(4000);
        }
    }, [templateNote]);

    const handleNote = (note) => {
        const lengthOfNote = note.length;
        if (lengthOfNote <= 4000) {
            setTemplateNote(note);
        } else {
            const sliceLastIdx = 4000 - lengthOfNote;
            setTemplateNote(note.slice(0, sliceLastIdx));
            setTemplateNotesPopup(true);
        }
    };

    const handlePopupOnKeyPress = () => {
        if (templateNote.length >= 4000) {
            setTemplateNotesPopup(true);
            closekeyBoard();
        }
    };

    const hasResolvedDistrictSelection = () => {
        if (!selectedDistrictId) {
            return false;
        }
        if (!isFromOrderHistory || !districts?.length) {
            return true;
        }
        return districts.some(
            (district) => district?.districtCode === selectedDistrictId
        );
    };

    const hasResolvedTerritorySelection = () => {
        if (!selectedTerritoryId) {
            return false;
        }
        if (!isFromOrderHistory) {
            return true;
        }
        return (territories || []).some(
            (territoryOption) =>
                territoryOption?.terrirotryCode === selectedTerritoryId
        );
    };

    const canSaveTemplate = () =>
        !!templateName &&
        hasResolvedDistrictSelection() &&
        hasResolvedTerritorySelection();

    const callCreateTemplate = () => {
        if (canSaveTemplate()) {
            const resolvedPhysicianIds =
                templateParams.templateDetails?.physicians?.length
                    ? templateParams.templateDetails.physicians
                    : isFromOrderHistory &&
                      orderTemplateStore?.physiciansSelected?.length
                    ? orderTemplateStore.physiciansSelected.map(
                          (ph) => ph?.physicianId
                      ).filter(Boolean)
                    : [];
            let templateRequest = {
                templateDetails: {
                    ...templateParams.templateDetails,
                    templateName: templateName.trim(),
                    addToFavorite: isFavorite,
                    notes: templateNote,
                    accounts:
                        templateParams.templateDetails?.accounts?.join(','),
                    physicians: resolvedPhysicianIds.join(','),
                    procedureCode: Procedure,
                    territoryId:
                        employeeRole !== CC_USER_ROLE
                            ? selectedTerritoryId === ALLTERRITORIES
                                ? ''
                                : selectedTerritoryId
                            : '',
                    districtId:
                        employeeRole !== CC_USER_ROLE 
                            ? selectedDistrictId === ALLDISTRICTS 
                                ? ''
                                : selectedDistrictId
                            : '',
                    expirationDate: surgeryDate ? surgeryDate : '',
                },
                cartData: {
                    products: getTemplateProducts(),
                },
            };
            dispatch(createTemplate(templateRequest));
        }
    };

    const getTemplateProducts = () => {
        if (
            orderDataStatus.itemProductsCount ||
            orderDataStatus.setProductsCount
        ) {
            let orders = [];
            orderDataStatus.itemProductsCount &&
                orders.push(...orderDataStatus.itemProducts);
            orderDataStatus.setProductsCount &&
                orders.push(...orderDataStatus.setProducts);
            return orders.map((pr) => {
                const product = {
                    productCFN: pr.cfn,
                    salesOrg: pr.salesOrg,
                    quantity: pr?.quantity ? pr.quantity : 1,
                };
                if (pr.bundleItems?.length) {
                    product.bundleItems = pr.bundleItems.map((item) => ({
                        cfn: item.cfn,
                        salesOrg: item.salesOrg,
                        quantity: item?.quantity ? item.quantity : 1,
                    }));
                }
                return product;
            });
        }
        return cartProduct.map((it) => {
            const hasBundleItems = it.bundleItems?.length || Object.prototype.hasOwnProperty.call(it, 'children');
            if (hasBundleItems) {
                const items = it.bundleItems || it.children;
                return {
                    productCFN: it.productCFN,
                    salesOrg: it.salesOrg,
                    quantity: it.quantity,
                    bundleItems: items.map((item) => ({
                        cfn: item.cfn ? item.cfn : item.productCFN,
                        salesOrg: item.salesOrg,
                        quantity: item?.quantity ? item.quantity : 1,
                    })),
                };
            }
            return {
                productCFN: it.productCFN,
                salesOrg: it.salesOrg,
                quantity: it.quantity,
            };
        });
    };

    const onDistrictChange = (value) => {
        setSelectedDistrict(value?.districtId);
        setSelectedTerritory('');
        setTemplateParams({
            ...templateParams,
            templateDetails: {
                ...templateParams.templateDetails,
                accounts: [],
                physicians: [],
            },
        });
        setAccountsObjectList([]);
        setPhysicianObjectList([]);
        dispatch(
            clearSingleDropDownList({
                name: 'accounts',
            })
        );
        dispatch(
            getDropdownValues({
                dropDownName: 'accounts',
                districtId: value?.districtId,
            })
        );
        dispatch(
            clearSingleDropDownList({
                name: 'territories',
            })
        );
        dispatch(
            getDropdownValues({
                dropDownName: 'territories',
                value: value?.districtId === ALLDISTRICTS ? '' : value?.districtId,
            })
        );
    };

    const onTerritoryChange = (value) => {
        setSelectedTerritory(value?.territoryId);
        setTemplateParams({
            ...templateParams,
            templateDetails: {
                ...templateParams.templateDetails,
                accounts: [],
                physicians: [],
            },
        });
        setAccountsObjectList([]);
        setPhysicianObjectList([]);
        dispatch(
            clearSingleDropDownList({
                name: 'accounts',
            })
        );
        dispatch(
            getDropdownValues({
                dropDownName: 'accounts',
                districtId: value?.districtId,
            })
        );
    };

    const closekeyBoard = () => {
        document.activeElement.blur();
    };

    const getDistrictView = () => {
        if (districts?.length > 1) {
            return (
                <Select
                    id="equity-index-cart-districtId"
                    value={selectedDistrictId}
                    options={districts}
                    onChange={onDistrictChange}
                    placeholder={t(
                        'equity.common.createTemplate.selectDistrict'
                    )}
                    optionValue="districtCode"
                    optionLabel="districtName"
                    name="districtId"
                    onOpen={onOpen}
                    onClose={onClose}
                    itemTemplate={(option) => {
                        if (option) {
                            return (
                                <SelectedCurrentLoc
                                    width={
                                        window.innerWidth <= sizes.mobileDevice
                                            ? '240px'
                                            : '100%'
                                    }
                                    whiteSpace={'pre-wrap'}
                                >
                                    {option.districtName}
                                </SelectedCurrentLoc>
                            );
                        }
                    }}
                    valueTemplate={(option, props) => {
                        if (option) {
                            return (
                                <SelectedCurrentLoc
                                    width={
                                        window.innerWidth <= '360'
                                            ? '215px'
                                            : '240px'
                                    }
                                >
                                    {option.districtName}
                                </SelectedCurrentLoc>
                            );
                        }
                        return <div>{props.placeholder}</div>;
                    }}
                />
            );
        }
        return (
            <AccPhysProceValue>
                {
                    getObjectFromArray(
                        districts,
                        'districtCode',
                        districtId || selectedDistrictId
                    )?.districtName
                }
            </AccPhysProceValue>
        );
    };

    const getTerritoryView = () => {
        if (territories?.length > 1) {
            return (
                <>
                    <Select
                        id="equity-index-cart-territoryId"
                        value={selectedTerritoryId || territory.terrirotryCode}
                        options={
                            territories?.length
                                ? territories
                                : territory
                                ? territory
                                : []
                        }
                        onChange={onTerritoryChange}
                        placeholder={t(
                            'equity.common.createTemplate.selectTerritory'
                        )}
                        optionValue="terrirotryCode"
                        optionLabel="terrirotryName"
                        name="territoryId"
                        onOpen={onOpen}
                        onClose={onClose}
                    />
                </>
            );
        }
        return (
            <AccPhysProceValue>
                {
                    getObjectFromArray(
                        territories,
                        'terrirotryCode',
                        territoryId || selectedTerritoryId
                    )?.terrirotryName
                }
            </AccPhysProceValue>
        );
    };

    const handleDropdownHeight = (rect, isPhysician) => {
        const templateContainer = document.getElementById('templateContainer');
        const templat = templateContainer?.getBoundingClientRect();
        if (templat?.bottom && rect?.y) {
            setDropdownHeight(templat.bottom - rect.y - 100);
        }
        setDisableFields({
            ...disableFields,
            physician: isPhysician,
            account: !isPhysician,
        });
    };

    const handleDropdownOnScroll = () => {
        setDisableFields({
            ...disableFields,
            account: false,
            physician: false,
        });
        closekeyBoard();
    };

    const getFeeCount = () => {
        const setCount = cartProduct.filter(
            (it) => it.materialType === 'DIEN'
        ).length;
        if (orderDataStatus.setProductsCount) {
            return `${orderDataStatus.setProductsCount} ${
                orderDataStatus.setProductsCount > 1
                    ? t('templates.equityTemplates.fees')
                    : t('equity.common.templateDetails.fee')
            }`;
        }
        if (setCount > 0) {
            return `${setCount} ${
                setCount > 1
                    ? t('templates.equityTemplates.fees')
                    : t('equity.common.templateDetails.fee')
            }`;
        }
        return null;
    };
    const getItemCount = () => {
        const itemCount = cartProduct.filter((pr) => !pr.isSet).length;
        if (orderDataStatus.itemProductsCount) {
            return `${orderDataStatus.itemProductsCount} ${
                orderDataStatus.itemProductsCount > 1
                    ? t('consignment.itemList.items')
                    : t('templates.templatesList.item')
            }`;
        }
        if (itemCount > 0) {
            return `${itemCount} ${
                itemCount > 1
                    ? t('consignment.itemList.items')
                    : t('templates.templatesList.item')
            }`;
        }
        return null;
    };

    // const onChangeHandler = (fieldName, value) => {

    //     console.log('value=====>',value);
    //     if (fieldName === 'surgeryDate') {
    //         const surgeryDate = convertDateToISOString(new Date(value), 'end');
    //         console.log('date==>',surgeryDate);
    //         setInputFields({
    //             ...inputFields,
    //             surgeryDate: surgeryDate,
    //         });
    //         console.log('input==',inputFields);
    //     } else {
    //         setInputFields({
    //             ...inputFields,
    //             [fieldName]: value,
    //         });
    //     }
    // };
    const onChangeHandler = (date) => {
        if (date === '') {
            setSurgeryDate(
                // moment(new Date().setHours(0, 0, 0, 0)).format(
                //     'YYYY-MM-DD[T]HH:mm:ss[Z]'
                // )
                ''
            );
        } else {
            setSurgeryDate(moment(date).format('YYYY-MM-DD[T]HH:mm:ss[Z]'));
        }
    };
    useEffectWithErrorLogging(()=>{
             dispatch(getConfigurations({
                   resourceType: 'visibility',
                    module: TEMPLATES,
                    orderType: 'ZOR'
                    }, TEMPLATES));

    },[]);

    return (
        <>
            <TemplateTitleContainer>
                <TemplateTitle showAstrisk={false}>
                    {t('equity.common.createTemplate.templateDetails')}
                </TemplateTitle>
                {/* <Icon 
                id="equity-createTemplate-closeIcon"
                mobilePath={Close} onClick={() => handleClose(false)} /> */}
            </TemplateTitleContainer>

            {createTemplateStore.loading || orderTemplateStore.loading ? (
                <Spinner id="equity-createTemplate-createTemplate-loadingSpinner" animation="border" variant="primary" small />
            ) : (
                <TemplateContainer
                    id={'templateContainer'}
                    height={'calc(100% - 25px)'}
                    paddingBottom={'56px'}
                    onScroll={handleDropdownOnScroll}
                    scrollBarWidth={'7px'}
                    scrollBarBorderRadius={'25px'}
                    scrollbarTrackMargin={'2px 0 81px 0'}
                    scrollBarBackgroundColor={'#808080'}
                    scrollBarBackGroundColorOnHover={'#00000029'}
                    mediumDeviceScrollBarDisplay={'block'}
                >
                    <CustomizeRowView
                        margin={
                            employeeRole !== CC_USER_ROLE
                                ? '15px 4.5px 0px -2px'
                                : '40px 4.5px 10px -2px'
                        }
                        mobileMargin={
                            employeeRole === CC_USER_ROLE &&
                            '15px 7px 20px 10px'
                        }
                    >
                        <ChipContainer>
                            <Chip
                                className="chipName"
                                label={t('equity.common.createTemplate.equity')}
                            />
                            <Chip
                                className="chipName"
                                label={t('equity.common.createTemplate.user')}
                            />
                            {getFeeCount() ? (
                                <Chip
                                    className="chipName"
                                    label={getFeeCount()}
                                />
                            ) : null}
                            {getItemCount() ? (
                                <Chip
                                    className="chipName"
                                    label={getItemCount()}
                                />
                            ) : null}
                        </ChipContainer>

                        {employeeRole !== CC_USER_ROLE && (
                            <FavoriteIconContainer
                                marginRight="9px"
                                marginTop={!isMobileDevice() && '0px'}
                                marginBottom={isMobileDevice() && '10px'}
                                onClick={favoriteOrUnfavorite}
                            >
                                <FavouriteIcon
                                    mobilePath={
                                        isFavorite
                                            ? FavoriteActive
                                            : FavoriteInActive
                                    }
                                />
                            </FavoriteIconContainer>
                        )}
                    </CustomizeRowView>
                    <AccountPhysicianProceduContainer>
                        <CommonItemsMainContainer>
                            <CommonItemsContainer
                                flexbasis="100%"
                                hideMargin={
                                    employeeRole !== CC_USER_ROLE ? true : false
                                }
                                marginLeft={isMobileDevice() ? '29px' : '18px'}
                                marginRight={'24px'}
                            >
                                <AccPhysProceTitle
                                    marginLeft={'0px'}
                                    showAstrisk={true}
                                >
                                    {t(
                                        'equity.common.createTemplate.templateName'
                                    )}
                                </AccPhysProceTitle>
                                <AutoCompleteDiv>
                                    <Input
                                        value={templateName}
                                        onChange={handleTemplateName}
                                        placeholder={t(
                                            'equity.common.createTemplate.enterTemplateName'
                                        )}
                                    />
                                </AutoCompleteDiv>
                            </CommonItemsContainer>
                            {employeeRole !== CC_USER_ROLE &&
                            employeeRole !== ITA_USER_ROLE ? (
                                <>
                                    <CommonItemsContainer
                                        flexbasis="40%"
                                        marginLeft={isMobileDevice() ? '29px' : '18px'}
                                        marginRight={'24px'}
                                    >
                                        <AccPhysProceTitle
                                            marginLeft={'0px'}
                                            showAstrisk={true}
                                        >
                                            {t(
                                                'equity.common.createTemplate.district'
                                            )}
                                        </AccPhysProceTitle>
                                        {getDistrictView()}
                                    </CommonItemsContainer>
                                    <CommonItemsContainer
                                        flexbasis="40%"
                                        marginLeft={isMobileDevice() ? '29px' : '18px'}
                                        marginRight={'24px'}
                                    >
                                        <AccPhysProceTitle
                                            marginLeft={'0px'}
                                            showAstrisk={true}
                                        >
                                            {t(
                                                'equity.common.createTemplate.territory'
                                            )}
                                        </AccPhysProceTitle>
                                        {getTerritoryView()}
                                    </CommonItemsContainer>

                                    <RowContainer>
                                        <AccountGroup>
                                            <CommonItemsContainer
                                                flexbasis="40%"
                                                marginLeft={isMobileDevice() ? '29px' : '18px'}
                                                marginRight={'24px'}
                                            >
                                                <AccPhysProceTitle
                                                    marginLeft={'0px'}
                                                >
                                                    {t(
                                                        'equity.common.createTemplate.account'
                                                    )}
                                                </AccPhysProceTitle>
                                                {accountsObjectList?.length > 0 ? (
                                                    <DeleteIconView>
                                                        {accountsObjectList?.map(
                                                            (
                                                                account,
                                                                index
                                                            ) => (
                                                                <>
                                                                    <div
                                                                        key={
                                                                            index
                                                                        }
                                                                        style={{
                                                                            display:
                                                                                'flex',
                                                                            flexDirection:
                                                                                'row',
                                                                            justifyContent:
                                                                                'space-between',
                                                                            width: '100%',
                                                                        }}
                                                                    >
                                                                        <AccPhysProceValue>
                                                                            <span className="equity-account-dt-mask">{
                                                                                account.accountName
                                                                            }</span>{' '}
                                                                            <div className="equity-account-dt-mask"
                                                                                style={{
                                                                                    fontFamily:
                                                                                        'AvenirNextWorld Italic',
                                                                                    fontSize:
                                                                                        '15px',
                                                                                    display:
                                                                                        'flex',
                                                                                    alignItems:
                                                                                        'center',
                                                                                }}
                                                                            >
                                                                                {accountNumberZeroTrimmer(
                                                                                    account.accountId
                                                                                )}
                                                                            </div>
                                                                        </AccPhysProceValue>
                                                                        <Icon
                                                                            mobilePath={
                                                                                DeleteIcon
                                                                            }
                                                                            id={
                                                                                `equity-template-remove-account-${accountsObjectList.indexOf(account)}`
                                                                            }
                                                                            onClick={
                                                                                () => handleRemoveAccountFromTemplate({ target: { id: account.accountId } })
                                                                            }
                                                                        />
                                                                    </div>
                                                                </>
                                                            )
                                                        )}
                                                    </DeleteIconView>
                                                ) : null}
                                            </CommonItemsContainer>
                                            <CommonItemsContainer
                                                flexbasis="40%"
                                                marginLeft={isMobileDevice() ? '29px' : '18px'}
                                                marginRight={'24px'}
                                                hideMargin={accountsObjectList?.length === 0}
                                            >
                                                {accountsObjectList?.length >
                                                    0 && (
                                                    <AccPhysProceTitle
                                                        marginLeft={'0px'}
                                                    >
                                                        {t(
                                                            'equity.common.createTemplate.addMoreAccounts'
                                                        )}
                                                    </AccPhysProceTitle>
                                                )}
                                                <div
                                                    id={'accountContainer'} 
                                                >
                                                    <AutoComplete
                                                        showScrollBar={true}
                                                        disableClearable={false}
                                                        inputRef={accountRef}
                                                        zIndex={99999999}
                                                        boxShadow={
                                                            '0px 3px 6px #00000029'
                                                        }
                                                        options={
                                                            filteredAccountList
                                                        }
                                                        value={''}
                                                        inputValue={
                                                            accountValue
                                                        }
                                                        itemTemplate={(
                                                            option
                                                        ) =>
                                                            AccountTemplate(
                                                                option,
                                                                'account'
                                                            )
                                                        }
                                                        onChange={(
                                                            value,
                                                            reason
                                                        ) => {
                                                            if (reason==='clear') {
                                                                handleOnfocus(
                                                                    null,
                                                                    'accounts'
                                                                );
                                                                handleSearch(
                                                                    '',
                                                                    '',
                                                                    reason,
                                                                    'account'
                                                                );
                                                                setDisableFields({
                                                                ...disableFields,
                                                                account: true,
                                                            });  
                                                            } else {
                                                                handleAddAccountToTemplate(
                                                                    value,
                                                                    reason
                                                                );
                                                            }
                                                        }}
                                                        placeholder={t(
                                                            'equity.common.createTemplate.searchAccount'
                                                        )}
                                                        field="accountFormattedName"
                                                        filterField="filterValue"
                                                        optionValue="accountId"
                                                        id="equity-submit-createTemplate-accounts"
                                                        onInputChange={(
                                                            event,
                                                            value,
                                                            reset
                                                        ) => {
                                                            if(value){
                                                                handleSearch(
                                                                    event,
                                                                    value,
                                                                    reset,
                                                                    'account'
                                                                );}
                                                            else if(reset==='clear'){
                                                                    handleSearch(
                                                                    '',
                                                                    '',
                                                                    reset,
                                                                    'account'
                                                                );
                                                            }
                                                        }}
                                                        loading={
                                                            accountsOptionLoading
                                                        }
                                                        loadingText={t(
                                                            'common.loadingText'
                                                        )}
                                                        noOptionsText={
                                                            !accountsOptionLoading &&
                                                            filteredAccountList?.length ===
                                                                0
                                                                ? t(
                                                                      'calendar.filterResultsPanel.noOptionText'
                                                                  )
                                                                : accountsOptionLoading &&
                                                                  t(
                                                                      'common.loadingText'
                                                                  )
                                                        }
                                                        onFocus={(event) => {
                                                            handleOnfocus(
                                                                event,
                                                                'accounts'
                                                            );
                                                        }}
                                                        disabled={
                                                            !selectedTerritoryId
                                                        }
                                                        onClose={() => {
                                                            try {
                                                                setDisableFields(
                                                                    {
                                                                        ...disableFields,
                                                                        account: false,
                                                                    }
                                                                );
                                                            } catch (error) {
                                                                logErrorToConsole(error);
                                                            }
                                                        }}
                                                        onOpen={
                                                            ()=>{
                                                                 setDisableFields({
                                                                ...disableFields,
                                                                account: true,
                                                            });
                                                            }
                                                        }
                                                        open={
                                                            disableFields.account
                                                        }
                                                        hideNoOptionText={true}
                                                        detailsMargin={true}
                                                        marginLeft={'1.5px'}
                                                        dropdownHeight={
                                                            window.innerWidth >
                                                            sizes.mobileDevice
                                                                ? dropdownHeight
                                                                : undefined
                                                        }
                                                    />
                                                </div>
                                            </CommonItemsContainer>
                                        </AccountGroup>
                                    </RowContainer>
                                </>
                            ) : (
                                <MainContainerItems setMarginBottom={true}>
                                    <div style={{ display: 'flex' }}>
                                        <div
                                            style={{
                                                width: '100%',
                                            }}
                                        >
                                            <ExpirationTitle
                                                color={'#202124'}
                                                fontSize={'14px'}
                                                marginBottom={'5px'}
                                                fontFamily={
                                                    'AvenirNextWorld Regular'
                                                }
                                            >
                                                {t(
                                                    'templates.equityTemplates.expirationDate'
                                                )}
                                            </ExpirationTitle>
                                            <DatePicker
                                                border={'2px solid #ebeded'}
                                                opacity={
                                                    surgeryDate ? '1' : '0.7'
                                                }
                                                textOpacity={
                                                    surgeryDate ? '1' : '0.7'
                                                }
                                                fontSize={'16px'}
                                                datePickerDivWidth={'160px'}
                                                datePickerDivMbWidth={'100%'}
                                                datePickerDivMbHeight={'5vh'}
                                                datePopOverZIndex={999999}
                                                onChange={(event) =>
                                                    onChangeHandler(event)
                                                }
                                                datePickerCalendarIcon={
                                                    CalendarIcon
                                                }
                                                placeholder={getPlaceholderDateFormat()}
                                                selectedDateFromDatePicker={
                                                    surgeryDate
                                                }
                                                datePickerBgColor={'#FFFFFF'}
                                                iconHeight={'30px'}
                                                iconPaddingTop={'3%'}
                                                left={
                                                    surgeryDate ? '15px' : '9px'
                                                }
                                                minDate={
                                                    new Date(
                                                        date.setDate(
                                                            date.getDate() + 1
                                                        )
                                                    )
                                                }
                                            />
                                        </div>
                                    </div>
                                </MainContainerItems>
                            )}
                        </CommonItemsMainContainer>
                    </AccountPhysicianProceduContainer>
                    <Notes
                        moblieWidth="unset"
                        width="unset"
                        // height= 'unset'
                        cardHeaderMargin={isMobileDevice() ? '14px 0px 0px 23px': '8px 0px 0px 10px'}
                        contentBodyMargin={isMobileDevice() ? '13px 23px 0px 23px': '13px 23px 0px 12px'}
                        cardFooterMargin={isMobileDevice() ? '8px 0px 24px 23px': '8px 0px 24px 10px'}
                        boxShadow={
                            window.innerWidth <= sizes.mobileDevice
                                ? '0px 0px 6px #00000029'
                                : 'unset'
                        }
                        margin={
                            window.innerWidth <= sizes.mobileDevice
                                ? '28px 16px 20px 16px'
                                : '0px 0px 20px -8px'
                        }
                        title={t('more.common.templateDetails.templateNotes')}
                        note={templateNote}
                        updateNotes={handleNote}
                        helperText={`${
                            4000 - templateNote?.length < 0
                                ? 0
                                : 4000 - templateNote?.length
                        } ${t(
                            'consignmentBilling.priceOverride.charactersRemainingLabel'
                        )}`}
                        fontSize="14px"
                        rows="2"
                        maxLength={textAreaCharLimit}
                        onKeyPress={handlePopupOnKeyPress}
                        // lineHeight={'60px'}
                        textAreaHeight="80px !important"
                    />

                    {templateNotesPopup ? (
                        <AddedMoreThanTenItems
                            title={
                                templateNameErrorMsg
                                    ? templateNameErrorMsg
                                    : t('common.itemFormTitle')
                            }
                            onClose={() => {
                                setTemplateNotesPopup(false);
                                setTemplateNameErrorMsg(null);
                            }}
                            opacity={'1'}
                            zIndex={999999999}
                            background={'#00000080 0% 0% no-repeat padding-box'}
                        />
                    ) : null}
                </TemplateContainer>
            )}
            <FooterContainer>
                <EquityFooter
                    customStyle={{
                        padding: isMobileDevice()
                            ? '3px -16px 4px -16px'
                            : '0px -16px 0px -16px',
                        position: 'absolute',
                        width: { standard: '100%', smallDevice: '100%' },
                        inPaddingVertical: '19px 0px 18px 0px',
                    }}
                    selectedItems={
                        canSaveTemplate()
                            ? 'true'
                            : ''
                    }
                    createTemplate={true}
                    callCreateTemplate={callCreateTemplate}
                    cancelCreateTemplate={() => {
                        try {
                            handleClose(false);
                        } catch (error) {
                            logErrorToConsole(error);
                        }
                    }}
                    smallJustifyContent={'flex-end'}
                    tabletPortraitMargin={'0 45px 0 0'}
                    addIosPadding={true}
                    orderPageMobilePadding={orderPageMobilePadding}
                    footerButtonSize={footerButtonSize}
                    footerButtonMargin={footerButtonMargin}
                />
            </FooterContainer>
        </>
    );
};

export default CreateTemplate;
